import { useGetCommandes } from "modules/commande/api";
import { Commande } from "modules/commande/types/commande.interface";
import { useState, useEffect } from "react";
import { useDebouncedSearch } from "common/hooks";
import CommandeTable, {
  RowObjCommande,
} from "../default/components/commandeTable";
import { Spinner } from "components/Spinner";

const AllCommandes = () => {
  const [inputValue, setInputValue] = useState("");
  const [expired, setExpired] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);

  const debouncedSearch = useDebouncedSearch(inputValue, 400);
  const { data, hasNextPage, fetchNextPage, fetchPreviousPage, isLoading, isFetching } =
    useGetCommandes(expired, debouncedSearch || undefined);

  const flatData = data?.pages[currentPage - 1]?.data ?? [];

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch, expired]);

  const handleFormatData = (commandes: Commande[]): RowObjCommande[] => {
    return commandes.map((item) => ({
      _id: item._id,
      number: item.documentNumber.number,
      workspaceId: item.workspaceId,
      clientId: item.client.name,
      createdAt: item.createdAt,
      totalTTC: item.lineItems.reduce((acc, cur) => acc + cur.totalTTC, 0),
      totalHT: item.lineItems.reduce((acc, cur) => acc + cur.totalHT, 0),
      total: item.lineItems.reduce((acc, cur) => acc + cur.totalTTC, 0),
      updatedAt: item.updatedAt,
      archived: item.archived,
      lineItems: item.lineItems,
      ebpId: item.ebpId,
    }));
  };

  const handleFetchNextPage = () => {
    if (hasNextPage) {
      fetchNextPage();
      setCurrentPage(currentPage + 1);
    }
  };

  const handleFetchPrevPage = () => {
    if (currentPage > 1) {
      fetchPreviousPage();
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <div className="mt-5">
        {isLoading && !data ? (
          <div className="flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <CommandeTable
            tableData={handleFormatData(flatData)}
            inputValue={inputValue}
            setInputValue={setInputValue}
            isLoading={isFetching}
            currentPage={currentPage}
            totalPage={data?.pages[0]?.count || 0}
            hasNextPage={hasNextPage}
            handleFetchNextPage={handleFetchNextPage}
            handleFetchPrevPage={handleFetchPrevPage}
            handleTabChange={setExpired}
            expired={expired}
          />
        )}
      </div>
    </div>
  );
};

export default AllCommandes;
